import {
  getSign
} from './api';
import common from './old/public/common';
import config from '../config/config'
/*global wx*/

const wxJsSdk = {

  ready: false,
  myCallback: null,
  longitude: null,
  latitude: null,
  requestSign() {
    getSign({
      oprPkId: common.get('oprPkId'),
      url: location.href.split('#')[0],
      appType: 1
    }).then((data) => {
      if (data.status === config.ajaxStatus) {
        this.configWxMap(data.data[0]);
      } else {
        throw new Error();
      }
    }).catch((error) => {
      console.log('网络异常');
      console.log(error);
    });
  },

  /**
   * 微信JS-SDK初始化
   * @returns {Promise} Promise实例
   */
  init() {
    return new Promise((resolve, reject) => {
      if (this.ready) {
        resolve();
        return;
      }
      console.log('init');
      getSign({
        oprPkId: common.get('oprPkId'),
        url: location.href.split('#')[0],
        appType: 1
      }).then((data) => {
        let configInfo = data.data[0];
        if (data.status !== config.ajaxStatus) {
          reject();
        }
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: configInfo.appId, // 必填，公众号的唯一标识
          timestamp: configInfo.timestamp, // 必填，生成签名的时间戳
          nonceStr: configInfo.nonceStr, // 必填，生成签名的随机串
          signature: configInfo.signature, // 必填，签名
          jsApiList: [
            'checkJsApi', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone',
            'hideMenuItems', 'showMenuItems', 'hideAllNonBaseMenuItem', 'showAllNonBaseMenuItem', 'translateVoice', 'startRecord',
            'stopRecord', 'onVoiceRecordEnd', 'playVoice', 'onVoicePlayEnd', 'pauseVoice', 'stopVoice', 'uploadVoice', 'downloadVoice',
            'chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'getNetworkType', 'openLocation', 'getLocation', 'hideOptionMenu',
            'showOptionMenu', 'closeWindow', 'scanQRCode', 'chooseWXPay', 'openProductSpecificView', 'addCard', 'chooseCard', 'openCard'
          ], // 必填，需要使用的JS接口列表
          openTagList: ['wx-open-launch-weapp']  // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
        });
        wx.ready(() => {
          // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
          this.ready = true;
          resolve();
        });
        wx.error(() => {
          reject();
        });
      }).catch((e) => {
        reject(e);
      });
    });
  },
  configWxMap(configInfo) {
    window.console.log('config');
    wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: configInfo.appId, // 必填，公众号的唯一标识
      timestamp: configInfo.timestamp, // 必填，生成签名的时间戳
      nonceStr: configInfo.nonceStr, // 必填，生成签名的随机串
      signature: configInfo.signature, // 必填，签名
      jsApiList: [
        'checkJsApi', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone',
        'hideMenuItems', 'showMenuItems', 'hideAllNonBaseMenuItem', 'showAllNonBaseMenuItem', 'translateVoice', 'startRecord',
        'stopRecord', 'onVoiceRecordEnd', 'playVoice', 'onVoicePlayEnd', 'pauseVoice', 'stopVoice', 'uploadVoice', 'downloadVoice',
        'chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'getNetworkType', 'openLocation', 'getLocation', 'hideOptionMenu',
        'showOptionMenu', 'closeWindow', 'scanQRCode', 'chooseWXPay', 'openProductSpecificView', 'addCard', 'chooseCard', 'openCard'
      ] // 必填，需要使用的JS接口列表
    });
    wx.ready(() => {
      // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
      this.ready = true;
      if (this.myCallback) {
        wx.getLocation(this.myCallback);
        this.myCallback = null;
      }
    });
    wx.error(() => {
      window.console.log('error');
      this.callbackFail();
    });
  },

  callbackFail() {
    if (this.myCallback) {
      this.myCallback.fail();
      this.myCallback = null;
    }
  },

  getLocation(callback) {
    this.init().then(() => {
      wx.getLocation({
        type: callback.type, // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        success: (res) => {
          this.latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
          this.longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
          callback.success(res);
        },
        fail: () => {
          //定位失败，如果有上次的缓存，则使用上次的缓存的数据返回
          if (this.latitude && this.longitude) {
            let res = {};
            res.latitude = this.latitude;
            res.longitude = this.longitude;
            callback.success(res);
          } else {
            callback.fail();
          }
        }
      });
    }).catch(() => {
      if(callback && callback.catch){
        callback.catch();
      }
      // console.log(error);
    });
  },

  scanQRCode(callback) {
    this.init().then(() => {
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: (res) => {
          //兼容条形码扫描结果
          // if (res.resultStr.indexOf(",") >= 0) {
          //   let serialNumber = res.resultStr;
          //   let serial = serialNumber.split(",");
          //   res.resultStr = serial[serial.length - 1];
          // }
          callback.success(res.resultStr);
        },
        fail: () => {
          callback.fail();
        }
      });
    }).catch((error) => {
      console.log(error);
    });
  },
  scanQRCode2() {
    this.init().then(() => {
      wx.scanQRCode({
        needResult: 0, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: () => {
          //兼容条形码扫描结果
          // if (res.resultStr.indexOf(",") >= 0) {
          //   let serialNumber = res.resultStr;
          //   let serial = serialNumber.split(",");
          //   res.resultStr = serial[serial.length - 1];
          // }
          // callback.success(res.resultStr);
        },
        fail: () => {
          // callback.fail();
        }
      });
    }).catch((error) => {
      console.log(error);
    });
  },

  reConfig() {
    this.ready = false;
    this.requestSign();
  },

  openLocation(data) {
    console.log(data);
    this.init().then(() => {
      wx.openLocation({
        latitude: Number(data.latitude), // 纬度，浮点数，范围为90 ~ -90
        longitude: Number(data.longitude), // 经度，浮点数，范围为180 ~ -180。
        name: data.name, // 位置名
        address: data.address, // 地址详情说明
        scale: 14, // 地图缩放级别,整形值,范围从1~28。默认为最大
        infoUrl: '' // 在查看位置界面底部显示的超链接,可点击跳转
      });
    }).catch((error) => {
      console.log(error);
    });
  },

  closeWindow() {
    this.init().then(() => {
      wx.closeWindow();
    }).catch((error) => {
      console.log(error);
    });
  },
  previewImage(current,urls) {
    this.init().then(() => {
      wx.previewImage({
        current: current, // 当前显示图片的http链接
        urls: urls // 需要预览的图片http链接列表
      });
    }).catch((error) => {
      console.log(error);
    });
  },
  share: function (option, callBack) {
    // getOperInfo({oprPkId: this.$common.get("oprPkId")}).then(data => {
    //   if (data.status === this.$config.ajaxStatus) {
    //     this.operData = data.data[0];
    //   }
    // })
    var self = this;
    var call = callBack || function () {};

    var shareContent = {
      success: function () {
        call({
          resultcode: 200,
          msg: 'success'
        });
      },
      cancel: function () {
        call({
          resultcode: 401,
          msg: 'cancel'
        });
      },
      fail: function () {
        call({
          resultcode: 201,
          msg: 'fail'
        });
      }
    };
    shareContent = self.extend(shareContent, option, 1);
    this.init().then(() => {
      window.wx.ready(function () {
        window.wx.showOptionMenu();
        window.wx.onMenuShareAppMessage(shareContent);
        window.wx.onMenuShareTimeline(shareContent);
        window.wx.onMenuShareQQ(shareContent);
        window.wx.onMenuShareWeibo(shareContent);
      });
    });
  },
};
export default wxJsSdk;